


















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { ITablePage } from '@/interface/common';

@Component({
  name: 'tableComp'
})
export default class TableComp extends Vue {
  @Prop() public tablePage!: ITablePage;
  @Prop({ type: String, default: 'width:100%;'}) public tableStyle!: string;
  @Prop() public tableData!: any[];
  @Prop() public columnConfig!: any[];
  @Prop({ type: Boolean, default: true}) public showPage!: boolean;
  @Prop({ type: String, default: ''}) public title!: string;
  @Prop({ type: String }) public headerAlign!: string;
  @Prop({ type: Boolean, default: true }) public stripe!: string;
  @Prop({ type: Boolean, default: true }) public border!: string;
  // 表格头的样式
  @Prop() public headerCellStyle!: any;
  // 是否显示序号
  @Prop({default: false }) public showIndexType!: boolean;
  @Prop({ default: '' }) public rowKey!: string;
  // 是否为可选表格
  @Prop({ default: false }) public isMultipleSelection!: boolean;
  @Prop({ default: () => [] }) public disSelectable!: any;
  // 回显勾选
  @Prop({ default: false }) public reserveSelection?: any;
  // 不可选的条件，方法，返回值为布尔，true则不可选；
  @Prop() public disSelectableCondiction!: any;
  @Prop({ default: true }) public hideAllSelected!: boolean;

  @Emit('handle-size-change')
  public handleSizeChange(pageSize: number) {
    return pageSize;
  }

  @Emit('handle-current-change')
  public handleCurrentChange(currentPage: number) {
    return currentPage;
  }

  @Emit('row-click')
  public handleRowClick(row: any, column: any, event: any) {
    return { row, column };
  }
  @Emit('header-click')
  public handleHeaderClick(column: any, event: any) {
    return { column, event }
  }
  @Emit('selection-change')
  public handleSelectionChange(selection: any) {
    return selection;
  }
  @Emit('select')
  public handleSelect(selection: any, row: any) {
    return { selection, row };
  }
  @Emit('select-all')
  public handleSelectAll(selection: any) {
    return selection;
  }

  // 返回值用来决定这一行的 CheckBox 是否可以勾选
  public selectable(row: any) {
    if (this.disSelectableCondiction) {
      if (this.disSelectableCondiction(row)) {
        return false;
      }
    } else {
      if (this.disSelectable.length && this.disSelectable.includes(row.id)) {
        return false;
      }
    }
    return true;
  }
  // 获取表格实例
  public getTableRef() {
    return this.$refs.tableRef;
  }
}
